export const GlobalTheme = {
    colors:
    {
        neutralPrimaryBackground: '#FFFFFF',
        neutralSecondaryBackground: '#F4F4F5',
        neutralTertiaryBackground: '#F7F7F5',

        neutralPrimaryForeground: '#000000',
        neutralSecondaryForeground: '#111111',

        mutedBackground: '#F9F9F9',
        mutedForeground: '#737373',

        neutralPrimaryBorder: '#E6E6E6',

        successBackground: '#E9F9C4',
        successForeground: '#9BC53D',

        warningBackground: '#FFD2AD',
        warningForeground: '#F88211',
        
        errorBackground: '#FFB9B6',
        errorForeground: '#AD2E24',

        accentBackground: '#95bfe9',
        accentForeground: '#3C91E6',

        neutralInputBackground: '#FDFDFF',

        neutralPrimaryBackgroundRGB: '255, 255, 255',
        neutralSecondaryBackgroundRGB: '244, 244, 245',
        neutralTertiaryBackgroundRGB: '247, 247, 245',

        neutralPrimaryForegroundRGB: '0, 0, 0',
        neutralSecondaryForegroundRGB: '17, 17, 17',

        mutedBackgroundRGB: '249, 249, 249',
        mutedForegroundRGB: '115, 115, 115',

        neutralPrimaryBorderRGB: '230, 230, 230',

        successBackgroundRGB: '272, 208, 223',
        successForegroundRGB: '155, 197, 61',

        warningBackgroundRGB: '255, 210, 173',
        warningForegroundRGB: '248, 130, 17',

        errorBackgroundRGB: '255, 185, 182',
        errorForegroundRGB: '233, 25, 15',

        accentBackgroundRGB: '172, 208, 223',
        accentForegroundRGB: '60, 145, 230',

        neutralInputBackgroundRGB: '253, 253, 255',
        // ***
    },

    fontSize:
    {
        xxl: '30px',
        xl: '24px',
        lg: '16px',
        md: '14px',
        sm: '12px',
        xs: '10px',

        // ***
    },

    iconSize:
    {
        xxl: '36px',
        xl: '32px',
        lg: '28px',
        md: '24px',
        sm: '20px',
        xs: '16px',
    },

    cornerRadius:
    {
        sm: '4px',
        md: '6px',
        lg: '12px'
    },

    spacing:
    {
        none: '0',
        xs: '1px',
        sm: '5px',
        md: '10px',
        lg: '20px',
        xl: '30px',
        xxl: '50px'
    },

    breakPoints:
    {
        xs: "360px",
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        xxl: "1536px",
    }
}



